export const QUERY_KEY_INITIALS = {
	GET_FORM_EDIT_DETAILS: 'getFormEditDetails',
	GET_FORM_SUBMISSIONS: 'getFormSubmissions',
	GET_FORM_DETAILS: 'getFormDetails',
	SAVED_TABLE_FILTERS: 'saved-table-filters',
	GET_WORKSPACE_CANDIDATES: 'get-workspace-candidates',
	GET_USER_DETAILS: 'getUserDetails',
	USER_SETTINGS: 'user-settings',
	WORKSPACE_CANDIDATES_FILTERS: 'workspace-candidates-filters',
	SUBMISSION_CREATOR: 'submission-creator',
	SUBMISSION_COMMENTS: 'submission-comments',

	// Discover feature
	DISCOVER_JOBS: 'discover-jobs',
	DISCOVER_TAGS: 'discover-tags',
	DISCOVER_ADMIN_ACCESS: 'discover-admin-access',
	DISCOVER_COMPANIES: 'discover-companies',
	DISCOVER_INVESTORS: 'discover-investors',
	CHECK_FORM_EDIT_ACCESS: 'checkFormEditAccess',
	INTERVIEW_FEEDBACK: 'interview-feedback',
	INTERVIEW_FEEDBACK_PAGE_DATA: 'interview-feedback-page-data',
	INTERVIEW_FEEDBACK_LINK_FEEDBACKS: 'interview-feedback-link-feedbacks',
	INTERVIEW_SCHEDULING: 'interview-scheduling',
	GCAL_STATUS: 'gcal-status',
	FEEDBACK_FEED: 'feedback-feed',
	EXTERNAL_INTERVIEWERS: 'external-interviewers',
	POSSIBLE_DUPLICATES: 'possible-duplicates',
	RECENT_ACTIVITY: 'recent-activity',

	// Analytics feature
	PAGE_ANALYTICS: 'page-analytics',
	FORM_SUMMARIES: 'form-summaries',
	FORM_ANALYTICS: 'form-analytics',
	SUBMISSION_DETAIL: 'submission',

	// Pricing
	CURRENT_PLAN: 'current-plan',
	EXTRA_CREDITS: 'extra-credits',
	/** Not under EXTRA_CREDITS: a change invalidates that prefix and would requote $0. */
	EXTRA_CREDITS_CHARGE_PREVIEW: 'extra-credits-charge-preview',
	PRICING_PLANS: 'pricing-plans',
	STORAGE_USAGE: 'storage-usage',

	// AI Assistant
	FETCH_AI_QUERIES: 'fetch-ai-queries',

	// LinkedIn
	LINKEDIN_PROFILE: 'linkedin-profile',

	// Video transcript
	VIDEO_TRANSCRIPT: 'video-transcript',

	// Workspace locations
	WORKSPACE_LOCATIONS: 'workspace-locations',

	// Stages
	SUGGESTED_STAGES: 'suggested-stages',

	// Careers
	CAREERS_PAGE_DATA: 'careersPageData',
	CHECK_PAGE_EDIT_ACCESS: 'checkPageEditAccess',

	// AI agent — read-only preview shown in the full-page agent's showChanges sheet
	AGENT_SHOW_CHANGES_FORM: 'agentShowChangesForm',

	// Referrals
	REFERRAL_SETTINGS: 'referral-settings',
	REFERRAL_INPUT_FIELDS: 'referral-input-fields',
	CHECK_REFERRAL_ACCESS: 'check-referral-access',
	ACTIVE_REFERRAL_JOBS: 'active-referral-jobs',
	MY_REFERRALS: 'my-referrals',
	// Legacy keys kept for cache compatibility during transition
	REFERRERS_LIST: 'referrers-list',
	CUSTOM_REFERRAL_FORM: 'custom-referral-form',
	REFERRAL_STATS: 'referral-stats',

	// Workspace discovery
	DISCOVER_WORKSPACES: 'discover-workspaces',

	// Slack integration
	SLACK_STATUS: 'slack-status',

	// LinkedIn integration
	LINKEDIN_INTEGRATION_STATUS: 'linkedin-integration-status',

	// Feedback templates
	FEEDBACK_TEMPLATES: 'feedback-templates',
	WORKSPACE_FEEDBACK_TEMPLATES: 'workspace-feedback-templates',

	// Binary Agent
	AI_AGENT_CHATS: 'ai-agent-chats',
	AI_AGENT_MESSAGES: 'ai-agent-messages',
	AI_AGENT_FORM_MENTIONS: 'ai-agent-form-mentions',
	AI_AGENT_SKILLS: 'ai-agent-skills',

	// Move candidate
	MOVE_CANDIDATE_FORMS: 'move-candidate-forms',
	MOVE_CANDIDATE_DUP_CHECK: 'move-candidate-duplicate-check',

	// Scheduling links + availability
	PERSONAL_AVAILABILITY: 'personal-availability',
	GCAL_DWD_STATUS: 'gcal-dwd-status',
	AVAILABILITY_SLOTS: 'availability-slots',
	SCHEDULING_LINK_LIST: 'scheduling-link-list',
	SCHEDULING_FORM_USERS: 'scheduling-form-users',
	INTERVIEWER_BUSY: 'interviewer-busy',
	PUBLIC_BOOKING_LINK: 'public-booking-link',
	PUBLIC_BOOKING_SLOTS: 'public-booking-slots',

	// Assignments
	ASSIGNMENTS: 'assignments',
	ASSIGNMENT_SUBMISSIONS: 'assignment-submissions',
	ASSIGNMENT_SUBMISSION_DETAIL: 'assignment-submission-detail',
	ASSIGNMENT_FILL: 'assignment-fill',

	// Offer letters
	OFFER_TEMPLATES: 'offer-templates',
	OFFERS: 'offers',
	OFFER_AUTOFILL: 'offer-autofill',
	OFFER_SIGNING: 'offer-signing',

	// Changelog
	CHANGELOG_ENTRIES: 'changelog-entries',

	// MCP consent (oauth)
	MCP_CONSENT_PENDING_REQUEST: 'mcp-consent-pending-request',
};
